<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import { Badge, dateTimeShort } from '@smatch/cassiopeia-web-components';

    /* EXPORTS --------------------------------------------------------------------------------- */

    export let date: number | string;

    // Plugins
    import { t } from 'svelte-i18n';

    /* INTERNALS -------------------------------------------------------------------------------- */

    const checkNew = (date: number | string | undefined): boolean => {
        if (date === undefined) {
            return false;
        }

        const INTERVAL = new Date().getTime() - new Date(date).getTime();
        const DEADLINE = 4 * 24 * 60 * 60 * 1000;

        return INTERVAL > 0 && INTERVAL < DEADLINE;
    };

    $: isNew = checkNew(date);

</script>


{#if isNew}
    <Badge
        color = 'secondary'
        style = 'strong'
        size = 'md'
        label = { $t('component.auction.global.new') }
        description = { `Published on ${ dateTimeShort(date) }`}
        css = 'ml-1'
    />
{/if}